
import { Link, Route, Routes } from 'react-router-dom';
import './App.css';
import { Login } from './components/login/login';
import { Users } from './interfaces/UserInterface';
import { UnloggedAlert } from './components/login/Alerts';
import { useEffect, useState } from 'react';
import { API } from './features/constants';
import { PlanesAuditoriasInternas } from './components/planAuditorias/PlanesAuditoriasInternas';
import { InformesAuditoriasInternas } from './components/informeAuditorias/InformeAuditoriasInternas';
import { Procedimiento } from './components/procedimientos/procedimientos';
import { ListaProcedimientos } from './components/procedimientos/listaProcedimientos';

function App() {

  const [user, setUser] = useState<Users>({Id: "", User: "", Password: "", Nombre: ""});
  const [logged, setLogged] = useState(false);

  useEffect(()=>{
    if(user.Id === ""){
      setLogged(false);
      localStorage.clear();
    }
    else{
      setLogged(true);
      user.Password = "";
      user.User = "";

      localStorage.setItem("localUser",JSON.stringify(user));

    }
  },[user])
  
  return (
    <>
    <div id="header">
      <div className='m-2 logo'><Link to={API} style={{color:"black",textDecoration:"none"}}>Si.T.A</Link></div>
      <div className='ocultar-al-imprimir'>
        <button className='btn btn-outline-light mx-2'><Link to="/Planes-de-Auditorias">Planes de Auditorías</Link></button>
        <button className='btn btn-outline-light mx-2'><Link to="/Informes-de-Auditorias">Informes de Auditorías</Link></button>
        <button className='btn btn-outline-light mx-2'><Link to="/Procedimientos">Procedimientos</Link></button>
      </div>
      <div className='ocultar-al-imprimir'>
        <Login setUser={setUser}/>
      </div>
    </div>
    {
      logged?//rutas con permisos
      <div>
        <Routes>
          <Route path="/Planes-de-Auditorias" element={<PlanesAuditoriasInternas />} />
          <Route path="/Informes-de-Auditorias" element={<InformesAuditoriasInternas/>} />
          <Route path="/Procedimientos" element={<ListaProcedimientos />} />
        </Routes>
      </div>
      :// rutas sin permisos Muestra el cartel de inicie session
      <div>
        <Routes>
          <Route path='/'/>
          <Route path="/Planes-de-Auditorias" element={<UnloggedAlert/>}/>
          <Route path="/Informes-de-Auditorias" element={<UnloggedAlert/>} />
          <Route path="/Procedimientos" element={<UnloggedAlert/>} />
        </Routes>
      </div>
    }
    </>
  );
}

export default App;
